import { render, staticRenderFns } from "./productionCodeDetail.vue?vue&type=template&id=1d3c8e42&scoped=true&"
import script from "./productionCodeDetail.vue?vue&type=script&lang=js&"
export * from "./productionCodeDetail.vue?vue&type=script&lang=js&"
import style0 from "./productionCodeDetail.vue?vue&type=style&index=0&id=1d3c8e42&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3c8e42",
  null
  
)

export default component.exports